/** Read team score from API `scores: [{ name, score }]`. */
export const getTeamScore = (game, teamName) => {
  if (!game || !teamName) return null;
  const entry = game.scores?.find((s) => s.name === teamName);
  return entry?.score ?? null;
};

export const hasLiveScores = (game) =>
  Array.isArray(game?.scores) &&
  game.scores.some((s) => s?.score != null && s.score !== "");

export const formatTeamScore = (game, teamName, fallback = "—") => {
  const score = getTeamScore(game, teamName);
  return score != null && score !== "" ? score : fallback;
};
